import { Components, Theme } from "@mui/material";
import { Shades } from "style/Colors";

export const MuiTableRow: Components<Theme>["MuiTableRow"] = {
  styleOverrides: {
    root: {
      backgroundColor: Shades.gray10,
      fontSize: 16,
    },
  },
};
